<template>
  <div class="features">
    <div class="ri-glbl-small-display">
      Enjoy all the benefits
    </div>
    <transition name="slide-fade">
      <div class="features-list">
        <feature-row
          v-for="feature in features"
          :key="feature"
          class="margin-top-m"
        >
          <span class="ri-glbl-medium-body">{{ feature }}</span>
        </feature-row>
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import featureRow from './FearuteRow.vue';

const features = ref([
  'Get a monthly forecast of your finances',
  'All your accounts, income and spending in one place',
  'Personalised insights and recommendations',
  'Goal setting with regular updates',
  'Join our worldwide community',
  'Expert support from real humans',
]);

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';

.features-list {
  text-align: left;
}

</style>
